import styled from "styled-components";

export const ButtonBubble = styled.button`
  display: flex;
  border: none;
  padding: 0;
  margin: 0;
  height: 36px;
  text-decoration: none;
  background: transparent;
  font-family: sans-serif;
  font-size: 1em;
  cursor: pointer;
  text-align: center;
  -webkit-appearance: none;
  -moz-appearance: none;
`;

export const LoadingWrapper = styled.span`
  display: inline-block;
`;
